import { render, staticRenderFns } from "./ValuationsTab.vue?vue&type=template&id=31617ad8&"
import script from "./ValuationsTab.vue?vue&type=script&lang=js&"
export * from "./ValuationsTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports